module.exports = __webpack_public_path__ + "2a4be2a34f14f388cc4478164076ca49.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/espacio.png
// module id = 599
// module chunks = 0